import React from 'react';
import { connect } from 'react-redux';
import { validateFloat } from "../../common/validation/Validators"
import Select from 'react-select'

const AllowanceField = ({ index, currency, filteredList, selectedAllowance, allowances, disabled, updateAllowance, setAllowances }) => {
    if (!selectedAllowance && filteredList?.length) updateAllowance({ index, type: filteredList[0].value })

    return (
        <div className="col-lg-12 col-xs-12" key={selectedAllowance?.value}>
            <div className="col-lg-4 col-xs-4 pl-0">
                <div className='form-material form-container' key={selectedAllowance?.value}>
                    <label >Type</label>
                    <Select
                        value={selectedAllowance}
                        isDisabled={disabled}
                        onChange={(selected) => {
                            updateAllowance({ index, type: selected?.value || null })
                        }}
                        options={filteredList}
                        auto
                    />
                </div>
            </div>
            <div className="col-lg-2 col-xs-2 pl-0">
                <div className='form-material form-container'>
                    <label>Method</label>
                    <input
                        className="form-control form-input"
                        value={selectedAllowance?.method}
                        disabled
                    />
                </div>
            </div>
            <div className="col-lg-2 col-xs-2 pl-0">
                <div className='form-material form-container'>
                    <label >Applied</label>
                    <input
                        className="form-control form-input"
                        value={selectedAllowance ? selectedAllowance?.taxable ? 'Pre-Tax' : 'Post-Tax' : ''}
                        disabled
                    />
                </div>
            </div>
            <div className="col-lg-2 col-xs-2 pl-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Amount</label>
                    <div style={{ position: 'absolute', top: 8}}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}
                        key={selectedAllowance?.value}
                        className="form-control form-input"
                        value={allowances?.[index]?.amount}
                        onChange={(e) => {
                            updateAllowance({ index, value: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-lg-2 col-xs-2">
                <button
                    disabled={disabled}
                    className='btn pull-right'
                    style={{ marginTop: '1.25rem' }}
                    onClick={() => {
                        if (disabled) return
                        setAllowances([...allowances.filter(item => item.type != allowances?.[index]?.type)])
                    }}
                >
                    <div style={{ float: "left" }}>Remove</div>
                </button>
            </div>
        </div>
    )

}


const mapStateToProps = (state, ownProps) => {

    return {
        currency: state.company?.settings?.currency,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AllowanceField);

